import { connect } from 'react-redux';
import FeaturedBadiPlus from './featured-badi-plus';
import { getToken } from 'app/datamodel/Auth/selectors';

export default connect((state) => ({
  token: getToken(state),
}))(FeaturedBadiPlus);
